import { Directive, OnInit, inject, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { distinctUntilChanged, Subscription } from 'rxjs';

@Directive({
  selector: '[StandardNumber]',
  standalone: true
})
export class StandardNumberDirective implements OnInit, OnDestroy {
  private ngControl = inject(NgControl);

  
  valueChangesSubscription: Subscription = new Subscription();


  ngOnInit(): void {
    const control = this.ngControl?.control!;
    this.valueChangesSubscription = control.valueChanges.pipe(
      distinctUntilChanged()
    )
    .subscribe(newValue => {
      const convertedValue = this.transformPersianToEnglishUnicode(newValue);
      control.setValue(convertedValue, {emitEvent: false});
    });
  }


  transformPersianToEnglishUnicode(value: string): string {

    const persianToEnglishDic = new Map()
      .set('\u06F0', '\u0030')
      .set('\u06F1', '\u0031')
      .set('\u06F2', '\u0032')
      .set('\u06F3', '\u0033')
      .set('\u06F4', '\u0034')
      .set('\u06F5', '\u0035')
      .set('\u06F6', '\u0036')
      .set('\u06F7', '\u0037')
      .set('\u06F8', '\u0038')
      .set('\u06F9', '\u0039')
      .set('\u0660', '\u0030')
      .set('\u0661', '\u0031')
      .set('\u0662', '\u0032')
      .set('\u0663', '\u0033')
      .set('\u0664', '\u0034')
      .set('\u0665', '\u0035')
      .set('\u0666', '\u0036')
      .set('\u0667', '\u0037')
      .set('\u0668', '\u0038')
      .set('\u0669', '\u0039');


    for (const char of value) {
      if (persianToEnglishDic.has(char))
        value = value.replace(char, persianToEnglishDic.get(char));
    }

    return value;
  }

  ngOnDestroy() {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }

}
